// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Paginate from "../models/Paginate.js";
import * as Buhta_cabinet__Route from "../Route.js";
import * as Buhta_core__Request from "../../../../packages/core/lib/Request.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as ReasonReactUpdate from "../../../../vendored/reason-react-update/ReasonReactUpdate.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Qs from "qs";
import * as React from "react";

function useGrid(headers, url, params, decode, param) {
  const routeUrl = Buhta_cabinet__Route.useUrl(undefined);
  const match = Buhta_cabinet__Route.useParamValue(routeUrl, "page");
  const setPageUrlParam = match[1];
  const match$1 = React.useState(function () {
    const __x = Buhta_cabinet__Route.getParamValue(routeUrl, "page", undefined);
    return {
      page: Belt__Belt_Option.mapWithDefault(__x, 1, Caml_format.caml_int_of_string),
      limit: 25
    };
  });
  const setPagination = match$1[1];
  const pagination = match$1[0];
  const match$2 = React.useState(function () {
    return false;
  });
  const setIsLastPage = match$2[1];
  const match$3 = ReasonReactUpdate.useReducer("Loading", (function (action, param) {
    if (typeof action === "string") {
      return {
        TAG: /* UpdateWithSideEffects */ 1,
        _0: "Loading",
        _1: (function (param) {
          const send = param.send;
          const urlParams_0 = [
            "paginate",
            Buhta_cabinet__Paginate.encode(pagination)
          ];
          const urlParams = {
            hd: urlParams_0,
            tl: /* [] */ 0
          };
          let uri;
          if (params !== undefined) {
            const query = Qs.stringify(Js__Js_dict.fromList(Stdlib.$at(urlParams, {
              hd: [
                "filter",
                Js__Js_dict.fromList(params.filter)
              ],
              tl: Belt__Belt_Option.mapWithDefault(params.params, /* [] */ 0, (function (params) {
                return params;
              }))
            })));
            uri = url + ("?" + query);
          } else {
            const query$1 = Qs.stringify(Js__Js_dict.fromList(urlParams));
            uri = url + ("?" + query$1);
          }
          const __x = Buhta_core__Request.get(undefined, headers, decode, undefined, uri);
          $$Promise.get(__x, (function (result) {
            if (result.TAG === /* Ok */ 0) {
              return Curry._1(send, {
                NAME: "Fetched",
                VAL: result._0
              });
            } else {
              return Curry._1(send, {
                NAME: "Failed",
                VAL: result._0
              });
            }
          }));
        })
      };
    }
    if (action.NAME === "Failed") {
      return {
        TAG: /* Update */ 0,
        _0: {
          NAME: "Error",
          VAL: action.VAL
        }
      };
    }
    const data = action.VAL;
    if (Stdlib__List.length(data.data) < 25) {
      Curry._1(setIsLastPage, (function (param) {
        return true;
      }));
    } else {
      Curry._1(setIsLastPage, (function (param) {
        return false;
      }));
    }
    return {
      TAG: /* Update */ 0,
      _0: {
        NAME: "Data",
        VAL: data
      }
    };
  }));
  const dispatch = match$3[1];
  const onPaginate = function (action) {
    let page;
    page = action === /* Next */ 0 ? pagination.page + 1 | 0 : pagination.page - 1 | 0;
    Curry._1(setPagination, (function (param) {
      return {
        page: page,
        limit: pagination.limit
      };
    }));
    Curry._1(setPageUrlParam, String(page));
  };
  React.useEffect((function () {
    Curry._1(dispatch, "Fetch");
  }), [
    pagination,
    params
  ]);
  return [
    match$3[0],
    [
      pagination.page,
      match$2[0]
    ],
    onPaginate
  ];
}

const decodeErrorResponse = Buhta_core__Request.decodeErrorResponse;

const defaultResponseHandler = Buhta_core__Request.defaultResponseHandler;

const convertJsResultPromise = Buhta_core__Request.convertJsResultPromise;

const get = Buhta_core__Request.get;

const post = Buhta_core__Request.post;

const put = Buhta_core__Request.put;

const useFetch = Buhta_core__Request.useFetch;

const useUrlFilters = Buhta_core__Request.useUrlFilters;

const useFilters = Buhta_core__Request.useFilters;

const useFilters2 = Buhta_core__Request.useFilters2;

export {
  decodeErrorResponse,
  defaultResponseHandler,
  convertJsResultPromise,
  get,
  post,
  put,
  useFetch,
  useUrlFilters,
  useFilters,
  useFilters2,
  useGrid,
}
/* Buhta_cabinet__Route Not a pure module */
